import OlMap from '@m1/ol-map';
import useMountEffect from '@restart/hooks/useMountEffect';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import React, { useRef } from 'react';

import Robot from './Robot';

import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import { MODE } from '@/define/robotStatus';
import useCameraFeedback from '@/hooks/useCameraFeedback';
import useIoTHubEvent from '@/hooks/useIoTHubEvent';
import useMission, { ArduPilot } from '@/hooks/useMissionForMavLink';
import useModeByStatus from '@/hooks/useModeByStatus';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';
import EventEmitter from '@/libs/EventEmitter';

const MapMapper = ({ data: robot }) => {
  const robotColor = useRef(robot.color);
  const globalPosition = useRobotTelemetry(robot.id, MESSAGE.GLOBAL_POSITION_INT);
  const homePosition = useRobotTelemetry(robot.id, MESSAGE.HOME_POSITION);
  const mode = useModeByStatus(robot);

  useCameraFeedback(robot.id);
  useIoTHubEvent(robot);
  useMission(ArduPilot, robot);

  useMountEffect(() => {
    const subscribeToken = EventEmitter.subscribe(`${robot.id}/event/removeGoto`, () => {
      OlMap.goto.remove(robot.id);
    });

    return () => {
      EventEmitter.unsubscribe(subscribeToken);
      OlMap.home.remove(robot.id);
      OlMap.goto.remove(robot.id);
    };
  });

  useUpdateEffect(() => {
    if (!globalPosition) return;
    if (!mode) return;

    const { lat, lng } = globalPosition;
    const isAnimated = [MODE.ARDUPILOT.PLANE.RTL.name, MODE.ARDUPILOT.PLANE.QRTL.name].includes(mode);

    OlMap.home.addPath(robot.id, { lat, lng }, isAnimated);
    OlMap.goto.addPath(robot.id, { lat, lng }, robotColor.current);
  }, [globalPosition, mode]);

  useUpdateEffect(() => {
    const { lat, lng } = homePosition;

    OlMap.home.addMarker(robot.id, { lat, lng }, robotColor.current);
  }, [homePosition]);

  useUpdateEffect(() => {
    robotColor.current = robot.color;
    OlMap.changeColor(robot.id, robotColor.current);
  }, [robot.color]);

  return <Robot data={robot} />;
};

export default MapMapper;
